export class ResourcesDownload {
  constructor() {
    this.more = document.querySelectorAll('.p-resources-download');

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.more.forEach((el) => {
      const moreButton = el.querySelector('.p-resources-download__more-button button');
      const moreContent = el.querySelector('.p-resources-download__more-list');

      moreButton.addEventListener('click', () => {
        const isOpen = moreButton.classList.contains('is-open');
        moreButton.classList.toggle('is-open', !isOpen);
        moreContent.style.height = isOpen ? '0' : `${moreContent.scrollHeight}px`;

        // ボタンのテキストを更新
        moreButton.textContent = isOpen ? 'もっと読む' : '閉じる';
      });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.more.forEach((el) => {
          const moreButton = el.querySelector('.p-resources-download__more-button button');
          const moreContent = el.querySelector('.p-resources-download__more-list');
          if (moreButton.classList.contains('is-open')) {
            moreContent.style.height = `${moreContent.scrollHeight}px`;
          }
        });
      }, 500);
    }, { passive: true });
  }
}
